import { lazy } from "react";

// Lazy-loaded Components
const SellerInvoiceAll = lazy(
  () => import("../components/invoice/SellerInvoiceAll"),
);
const AccountsContainer = lazy(
  () => import("../containers/accounts/AccountsContainer"),
);
const ADBannerImageLocationListContainer = lazy(
  () => import("../containers/adBanner/ADBannerImageLocationListContainer"),
);
const ADBannerImageTypeListContainer = lazy(
  () => import("../containers/adBanner/ADBannerImageTypeListContainer"),
);
const ADBannerListContainer = lazy(
  () => import("../containers/adBanner/ADBannerListContainer"),
);
const ADBannerTypeListContainer = lazy(
  () => import("../containers/adBanner/ADBannerTypeListContainer"),
);
const CreateADBannerTypeContainer = lazy(
  () => import("../containers/adBanner/CreateADBannerTypeContainer"),
);
const CreateAdBannerContainer = lazy(
  () => import("../containers/adBanner/CreateAdBannerContainer"),
);
const CreateADBannerImageLocationContainer = lazy(
  () => import("../containers/adBanner/CreateADBannerImageLocationContainer"),
);
const CreateADBannerImageTypeContainer = lazy(
  () => import("../containers/adBanner/CreateADBannerImageTypeContainer"),
);
const EditADBannerImageLocationContainer = lazy(
  () => import("../containers/adBanner/EditADBannerImageLocationContainer"),
);
const EditADBannerImageTypeContainer = lazy(
  () => import("../containers/adBanner/EditADBannerImageTypeContainer"),
);
const EditAdBannerContainer = lazy(
  () => import("../containers/adBanner/EditAdBannerContainer"),
);
const EditAdBannerTypeContainer = lazy(
  () => import("../containers/adBanner/EditAdBannerTypeContainer"),
);
const AdminListContainer = lazy(
  () => import("../containers/admin/AdminListContainer"),
);
const CreateAdminContainer = lazy(
  () => import("../containers/admin/CreateAdminContainer"),
);
const EditAdminContainer = lazy(
  () => import("../containers/admin/EditAdminContainer"),
);
const AppReleaseListContainer = lazy(
  () =>
    import("../containers/administrative/App-Release/AppReleaseListContainer"),
);
const CreateAppReleaseContainer = lazy(
  () =>
    import("../containers/administrative/App-Release/CreateAppReleaseContainer"),
);
const EditAppReleaseContainer = lazy(
  () =>
    import("../containers/administrative/App-Release/EditAppReleaseContainer"),
);
const ISRCachingContainer = lazy(
  () => import("../containers/administrative/ISR-Caching/ISRCachingContainer"),
);
const CachingListContainer = lazy(
  () => import("../containers/administrative/caching/CachingListContainer"),
);
const BillListContainer = lazy(
  () => import("../containers/bill/BillListContainer"),
);
const PrevReturnBillListContainer = lazy(
  () => import("../containers/bill/PrevReturnBillListContainer"),
);
const ReturnBillListContainer = lazy(
  () => import("../containers/bill/ReturnBillListContainer"),
);
const BlogCategoryListContainer = lazy(
  () => import("../containers/blog/BlogCategoryListContainer"),
);
const BlogPostListContainer = lazy(
  () => import("../containers/blog/BlogPostListContainer"),
);
const CreateBlogCategoryContainer = lazy(
  () => import("../containers/blog/CreateBlogCategoryContainer"),
);
const CreateBlogPostContainer = lazy(
  () => import("../containers/blog/CreateBlogPostContainer"),
);
const EditBlogCategoryContainer = lazy(
  () => import("../containers/blog/EditBlogCategoryContainer"),
);
const EditBlogPostContainer = lazy(
  () => import("../containers/blog/EditBlogPostContainer"),
);
const Applicants = lazy(() => import("../containers/career/Applicants"));
const Career = lazy(() => import("../containers/career/Career"));
const CommissionType = lazy(
  () => import("../containers/commission/CommissionType"),
);
const CommissionTypeList = lazy(
  () => import("../containers/commission/CommissionTypeList"),
);
const ContentPost = lazy(() => import("../containers/content/ContentPost"));
const ContentType = lazy(() => import("../containers/content/ContentType"));
const AddFestivalProductListContainer = lazy(
  () => import("../containers/festival/AddFestivalProductListContainer"),
);
const CreateFestiveContainer = lazy(
  () => import("../containers/festival/CreateFestiveContainer"),
);
const EditFestiveContainer = lazy(
  () => import("../containers/festival/EditFestiveContainer"),
);
const FestiveListContainer = lazy(
  () => import("../containers/festival/FestiveListContainer"),
);
const ViewFestivalProductListContainer = lazy(
  () => import("../containers/festival/ViewFestivalProductListContainer"),
);
const HomeContainer = lazy(() => import("../containers/home/HomeContainer"));
const GenerateBarcodeContainer = lazy(
  () => import("../containers/inventory/GenerateBarcodeContainer"),
);
const StockReportListContainer = lazy(
  () => import("../containers/inventory/StockReportListContainer"),
);
const OrderRequisition = lazy(
  () => import("../containers/orderRequisition/OrderRequisitionListContainer"),
);
const OrdersAccounts = lazy(
  () => import("../containers/orders/OrdersAccounts"),
);
const CancelOrdersListContainer = lazy(
  () => import("../containers/orders/CancelOrdersListContainer"),
);
const CreateOrderContainer = lazy(
  () => import("../containers/orders/CreateOrderContainer"),
);
const CreateOrderTypeAdminContainer = lazy(
  () => import("../containers/orders/CreateOrderTypeAdminContainer"),
);
const EditOrderTypeContainer = lazy(
  () => import("../containers/orders/EditOrderTypeContainer"),
);
const ManageOrderAdminContainer = lazy(
  () => import("../containers/orders/ManageOrderAdminContainer"),
);
const OrderTypeListContainer = lazy(
  () => import("../containers/orders/OrderTypeListContainer"),
);
const ReturnOrdersListContainer = lazy(
  () => import("../containers/orders/ReturnOrdersListContainer"),
);
const OutletListContainer = lazy(
  () => import("../containers/outlet/OutletListContainer"),
);
const CreateOutletContainer = lazy(
  () => import("../containers/outlet/CreateOutletContainer"),
);
const EditOutletContainer = lazy(
  () => import("../containers/outlet/EditOutletContainer"),
);
const UpdateParcelDeliveryContainer = lazy(
  () => import("../containers/parcel/UpdateParcelDeliveryContainer"),
);
const DeliveryListContainer = lazy(
  () => import("../containers/parcel/DeliveryListContainer"),
);
const CreatePaymentAdviceContainer = lazy(
  () => import("../containers/paymentAdvice/CreatePaymentAdviceContainer"),
);
const EditPaymentAdviceContainer = lazy(
  () => import("../containers/paymentAdvice/EditPaymentAdviceContainer"),
);
const PaymentAdviceApprovalListContainer = lazy(
  () =>
    import("../containers/paymentAdvice/PaymentAdviceApprovalListContainer"),
);
const PaymentAdviceListContainer = lazy(
  () => import("../containers/paymentAdvice/PaymentAdviceListContainer"),
);
const PaymentAdviceReportContainer = lazy(
  () => import("../containers/paymentAdvice/PaymentAdviceReportContainer"),
);
const CategoryWiseReportAuditContainer = lazy(
  () => import("../containers/audit/CategoryWiseReportAuditContainer"),
);
const CreatePaymentMethodContainer = lazy(
  () => import("../containers/paymentMethod/CreatePaymentMethodContainer"),
);
const EditPaymentMethodContainer = lazy(
  () => import("../containers/paymentMethod/EditPaymentMethodContainer"),
);
const PaymentMethodListContainer = lazy(
  () => import("../containers/paymentMethod/PaymentMethodListContainer"),
);
const DuplicateProductContainer = lazy(
  () => import("../containers/product/DuplicateProductContainer"),
);
const CreateProductAdminContainer = lazy(
  () => import("../containers/product/CreateProductAdminContainer"),
);
const EditProductContainer = lazy(
  () => import("../containers/product/EditProductContainer"),
);
const ManageProducts = lazy(
  () => import("../containers/product/ManageProducts"),
);
const EditProfileContainer = lazy(
  () => import("../containers/profile/EditProfileContainer"),
);
const ProfileContainer = lazy(
  () => import("../containers/profile/ProfileContainer"),
);
const CampaignTypeListContainer = lazy(
  () => import("../containers/campaign/CampaignTypeListContainer"),
);
const CreateCampaignTypeContainer = lazy(
  () => import("../containers/campaign/CreateCampaignTypeContainer"),
);
const EditCampaignTypeContainer = lazy(
  () => import("../containers/campaign/EditCampaignTypeContainer"),
);
const CampaignListContainer = lazy(
  () => import("../containers/campaign/CampaignListContainer"),
);
const CreateCampaignContainer = lazy(
  () => import("../containers/campaign/CreateCampaignContainer"),
);
const EditCampaignContainer = lazy(
  () => import("../containers/campaign/EditCampaignContainer"),
);
const ManageCampaignProductsContainer = lazy(
  () => import("../containers/campaign/ManageCampaignProductsContainer"),
);
const ModifyProductListContainer = lazy(
  () => import("../containers/campaign/ModifyProductListContainer"),
);
const CreateGeneralPurchaseOrderContainer = lazy(
  () =>
    import("../containers/purchaseOrder/CreateGeneralPurchaseOrderContainer"),
);
const CreatePurchaseOrderReceivedContainer = lazy(
  () =>
    import("../containers/purchaseOrder/CreatePurchaseOrderReceivedContainer"),
);
const CreateReturnPOContainer = lazy(
  () => import("../containers/purchaseOrder/CreateReturnPOContainer"),
);
const CreateStoreLocationContainer = lazy(
  () => import("../containers/purchaseOrder/CreateStoreLocationContainer"),
);
const EditPurchaseOrderReceivedContainer = lazy(
  () =>
    import("../containers/purchaseOrder/EditPurchaseOrderReceivedContainer"),
);
const EditReturnPOContainer = lazy(
  () => import("../containers/purchaseOrder/EditReturnPOContainer"),
);
const EditStoreLocationContainer = lazy(
  () => import("../containers/purchaseOrder/EditStoreLocationContainer"),
);
const GeneralPurchaseOrderListContainer = lazy(
  () => import("../containers/purchaseOrder/GeneralPurchaseOrderListContainer"),
);
const PurchaseOrderListContainer = lazy(
  () => import("../containers/purchaseOrder/PurchaseOrderListContainer"),
);
const PurchaseOrderReceivedApprovalListContainer = lazy(
  () =>
    import("../containers/purchaseOrder/PurchaseOrderReceivedApprovalListContainer"),
);
const ReceivedPurchaseOrderListContainer = lazy(
  () =>
    import("../containers/purchaseOrder/ReceivedPurchaseOrderListContainer"),
);
const ReturnPOApprovalListContainer = lazy(
  () => import("../containers/purchaseOrder/ReturnPOApprovalListContainer"),
);
const ReturnPOListContainer = lazy(
  () => import("../containers/purchaseOrder/ReturnPOListContainer"),
);
const StoreLocationListContainer = lazy(
  () => import("../containers/purchaseOrder/StoreLocationListContainer"),
);
const CreatePurchaseOrderContainer = lazy(
  () => import("../containers/purchaseOrder/CreatePurchaseOrderContainer"),
);
const POReportContainer = lazy(
  () => import("../containers/report/POReportContainer"),
);
const ReportContainer = lazy(
  () => import("../containers/report/ReportContainer"),
);
const SearchSuggestionsListContainer = lazy(
  () => import("../containers/searchSuggestion/SearchSuggestionsListContainer"),
);
const CreateSearchSuggestionContainer = lazy(
  () =>
    import("../containers/searchSuggestion/CreateSearchSuggestionContainer"),
);
const AccountsSellerVerification = lazy(
  () => import("../containers/seller/AccountsSellerVerification"),
);
const ApprovedSellerContainer = lazy(
  () => import("../containers/seller/ApprovedSellerContainer"),
);
const BankAccountsAdminContainer = lazy(
  () => import("../containers/seller/BankAccountsAdminContainer"),
);
const EditSellerNewContainer = lazy(
  () => import("../containers/seller/EditSellerNewContainer"),
);
const ApprovedReturnPolicyContainer = lazy(
  () => import("../containers/seller/ApprovedReturnPolicyContainer"),
);
const CreateNewSellerContainer = lazy(
  () => import("../containers/seller/CreateNewSellerContainer"),
);
const EditReturnPolicyContainer = lazy(
  () => import("../containers/seller/EditReturnPolicyContainer"),
);
const PendingReturnPolicyContainer = lazy(
  () => import("../containers/seller/PendingReturnPolicyContainer"),
);
const PendingSellerContainer = lazy(
  () => import("../containers/seller/PendingSellerContainer"),
);
const RejectedReturnPolicyContainer = lazy(
  () => import("../containers/seller/RejectedReturnPolicyContainer"),
);
const AreaListContainer = lazy(
  () => import("../containers/settings/address/AreaListContainer"),
);
const CityListContainer = lazy(
  () => import("../containers/settings/address/CityListContainer"),
);
const CountryListContainer = lazy(
  () => import("../containers/settings/address/CountryListContainer"),
);
const CreateAreaContainer = lazy(
  () => import("../containers/settings/address/CreateAreaContainer"),
);
const CreateCityContainer = lazy(
  () => import("../containers/settings/address/CreateCityContainer"),
);
const CreateCountryContainer = lazy(
  () => import("../containers/settings/address/CreateCountryContainer"),
);
const EditAreaContainer = lazy(
  () => import("../containers/settings/address/EditAreaContainer"),
);
const EditCityContainer = lazy(
  () => import("../containers/settings/address/EditCityContainer"),
);
const EditCountryContainer = lazy(
  () => import("../containers/settings/address/EditCountryContainer"),
);
const BrandListContainer = lazy(
  () => import("../containers/settings/brand/BrandListContainer"),
);
const CreateBrandContainer = lazy(
  () => import("../containers/settings/brand/CreateBrandContainer"),
);
const EditBrandContainer = lazy(
  () => import("../containers/settings/brand/EditBrandContainer"),
);
const CategoryListContainer = lazy(
  () => import("../containers/settings/category/CategoryListContainer"),
);
const CreateCategoryContainer = lazy(
  () => import("../containers/settings/category/CreateCategoryContainer"),
);
const CreateTopCategoryList = lazy(
  () => import("../containers/settings/category/CreateTopCategoryList"),
);
const EditCategoryContainer = lazy(
  () => import("../containers/settings/category/EditCategoryContainer"),
);
const EditTopCategoryList = lazy(
  () => import("../containers/settings/category/EditTopCategoryList"),
);
const TopCategoryListContainer = lazy(
  () => import("../containers/settings/category/TopCategoryListContainer"),
);
const ImportCurrencyContainer = lazy(
  () => import("../containers/settings/currency/ImportCurrencyContainer"),
);
const ImportCurrencyListContainer = lazy(
  () => import("../containers/settings/currency/ImportCurrencyListContainer"),
);
const CreateDiscountSummaryContainer = lazy(
  () =>
    import("../containers/settings/discount/CreateDiscountSummaryContainer"),
);
const CreateDiscountTypeContainer = lazy(
  () => import("../containers/settings/discount/CreateDiscountTypeContainer"),
);
const DiscountListContainer = lazy(
  () => import("../containers/settings/discount/DiscountListContainer"),
);
const DiscountSummaryListContainer = lazy(
  () => import("../containers/settings/discount/DiscountSummaryListContainer"),
);
const DiscountTypeListContainer = lazy(
  () => import("../containers/settings/discount/DiscountTypeListContainer"),
);
const EditDiscountContainer = lazy(
  () => import("../containers/settings/discount/EditDiscountContainer"),
);
const EditDiscountSummaryContainer = lazy(
  () => import("../containers/settings/discount/EditDiscountSummaryContainer"),
);
const EditDiscountTypeContainer = lazy(
  () => import("../containers/settings/discount/EditDiscountTypeContainer"),
);
const CreateInventoryList = lazy(
  () => import("../containers/settings/inventory/CreateInventoryList"),
);
const EditInventoryList = lazy(
  () => import("../containers/settings/inventory/EditInventoryList"),
);
const InventoryListContainer = lazy(
  () => import("../containers/settings/inventory/InventoryListContainer"),
);
const CreateProjectContainer = lazy(
  () => import("../containers/settings/projects/CreateProjectContainer"),
);
const EditProjectContainer = lazy(
  () => import("../containers/settings/projects/EditProjectContainer"),
);
const ProjectListContainer = lazy(
  () => import("../containers/settings/projects/ProjectListContainer"),
);
const CreateProductVariantContainer = lazy(
  () => import("../containers/settings/variant/CreateProductVariantContainer"),
);
const CreateProductVariantOptionContainer = lazy(
  () =>
    import("../containers/settings/variant/CreateProductVariantOptionContainer"),
);
const CreateProductVariantOptionValueContainer = lazy(
  () =>
    import("../containers/settings/variant/CreateProductVariantOptionValueContainer"),
);
const EditProductVariantContainer = lazy(
  () => import("../containers/settings/variant/EditProductVariantContainer"),
);
const EditProductVariantOptionContainer = lazy(
  () =>
    import("../containers/settings/variant/EditProductVariantOptionContainer"),
);
const EditProductVariantOptionValueContainer = lazy(
  () =>
    import("../containers/settings/variant/EditProductVariantOptionValueContainer"),
);
const ProductVariantListContainer = lazy(
  () => import("../containers/settings/variant/ProductVariantListContainer"),
);
const ProductVariantOptionListContainer = lazy(
  () =>
    import("../containers/settings/variant/ProductVariantOptionListContainer"),
);
const ProductVariantOptionValueListContainer = lazy(
  () =>
    import("../containers/settings/variant/ProductVariantOptionValueListContainer"),
);
const CreateVoucherContainer = lazy(
  () => import("../containers/settings/voucher/CreateVoucherContainer"),
);
const EditVoucherContainer = lazy(
  () => import("../containers/settings/voucher/EditVoucherContainer"),
);
const VoucherListContainer = lazy(
  () => import("../containers/settings/voucher/VoucherListContainer"),
);
const CourierCostListContainer = lazy(
  () => import("../containers/shipping/CourierCostListContainer"),
);
const CourierProductTypeListContainer = lazy(
  () => import("../containers/shipping/CourierProductTypeListContainer"),
);
const CourierProfileListContainer = lazy(
  () => import("../containers/shipping/CourierProfileListContainer"),
);
const CreateCourierCostContainer = lazy(
  () => import("../containers/shipping/CreateCourierCostContainer"),
);
const CreateCourierProductTypeContainer = lazy(
  () => import("../containers/shipping/CreateCourierProductTypeContainer"),
);
const CreateCourierProfileContainer = lazy(
  () => import("../containers/shipping/CreateCourierProfileContainer"),
);
const CreateShippingCostContainer = lazy(
  () => import("../containers/shipping/CreateShippingCostContainer"),
);
const CreateShippingOptionsContainer = lazy(
  () => import("../containers/shipping/CreateShippingOptionsContainer"),
);
const CreateShippingTypeContainer = lazy(
  () => import("../containers/shipping/CreateShippingTypeContainer"),
);
const EditCourierCostContainer = lazy(
  () => import("../containers/shipping/EditCourierCostContainer"),
);
const EditCourierProductTypeContainer = lazy(
  () => import("../containers/shipping/EditCourierProductTypeContainer"),
);
const EditCourierProfileContainer = lazy(
  () => import("../containers/shipping/EditCourierProfileContainer"),
);
const EditShippingOptionsContainer = lazy(
  () => import("../containers/shipping/EditShippingOptionsContainer"),
);
const EditShippingTypeContainer = lazy(
  () => import("../containers/shipping/EditShippingTypeContainer"),
);
const ShippingCostListContainer = lazy(
  () => import("../containers/shipping/ShippingCostListContainer"),
);
const ShippingOptionsListContainer = lazy(
  () => import("../containers/shipping/ShippingOptionsListContainer"),
);
const ShippingTypeListContainer = lazy(
  () => import("../containers/shipping/ShippingTypeListContainer"),
);
const SizeChartAttributeList = lazy(
  () => import("../containers/sizeChart/SizeChartAttributeList"),
);
const SizeChartAttributes = lazy(
  () => import("../containers/sizeChart/SizeChartAttributes"),
);
const SizeChartTemplateViewOrUpdate = lazy(
  () => import("../containers/sizeChart/SizeChartTemplateViewOrUpdate"),
);
const SizeGuideMeasurement = lazy(
  () => import("../containers/sizeChart/SizeGuideMeasurement"),
);
const SizeGuideMeasurementList = lazy(
  () => import("../containers/sizeChart/SizeGuideMeasurementList"),
);
const AllStoreBannerListAdminContainer = lazy(
  () => import("../containers/store/AllStoreBannerListAdminContainer"),
);
const CreateAdminStoreBannerContainer = lazy(
  () => import("../containers/store/CreateAdminStoreBannerContainer"),
);
const EditAdminStoreBannerContainer = lazy(
  () => import("../containers/store/EditAdminStoreBannerContainer"),
);
const WarrantyPeriod = lazy(
  () => import("../containers/warranty/WarrantyPeriod"),
);
const WarrantyPeriodList = lazy(
  () => import("../containers/warranty/WarrantyPeriodList"),
);
const WarrantyType = lazy(() => import("../containers/warranty/WarrantyType"));
const WarrantyTypeList = lazy(
  () => import("../containers/warranty/WarrantyTypeList"),
);
const CreateVideoBlogCategoryContainer = lazy(
  () => import("../containers/videoBlog/CreateVideoBlogCategoryContainer"),
);
const VideoBlogCategoryListContainer = lazy(
  () => import("../containers/videoBlog/VideoBlogCategoryListContainer"),
);
const EditVideoBlogCategoryContainer = lazy(
  () => import("../containers/videoBlog/EditVideoBlogCategoryContainer"),
);
const CreateVideoBlogPostContainer = lazy(
  () => import("../containers/videoBlog/CreateVideoBlogPostContainer"),
);
const VideoBlogPostListContainer = lazy(
  () => import("../containers/videoBlog/VideoBlogPostListContainer"),
);
const EditVideoBlogPostContainer = lazy(
  () => import("../containers/videoBlog/EditVideoBlogPostContainer"),
);

export const adminDashboardRoutes = [
  { path: "/Home", component: HomeContainer },
  { path: "/CreateOrder", component: CreateOrderContainer },
  { path: "/Profile", component: ProfileContainer },
  { path: "/EditProfile/:id", component: EditProfileContainer },
  { path: "/ApprovedSeller", component: ApprovedSellerContainer },
  { path: "/CreateProductAdmin", component: CreateProductAdminContainer },
  { path: "/Manage-Products", component: ManageProducts },
  { path: "/PendingSeller", component: PendingSellerContainer },
  { path: "/CreateNewSeller", component: CreateNewSellerContainer },
  { path: "/EditSeller", component: EditSellerNewContainer },
  { path: "/ManageOrdersAdmin", component: ManageOrderAdminContainer },
  { path: "/CreateOrderType", component: CreateOrderTypeAdminContainer },
  { path: "/CancelOrders", component: CancelOrdersListContainer },
  { path: "/ReturnOrders", component: ReturnOrdersListContainer },
  { path: "/OrdersTypeList", component: OrderTypeListContainer },
  { path: "/EditOrdersType", component: EditOrderTypeContainer },
  { path: "/ImportCurrency", component: ImportCurrencyContainer },
  { path: "/CurrencyRateList", component: ImportCurrencyListContainer },
  { path: "/CreateCategory", component: CreateCategoryContainer },
  { path: "/EditCategory", component: EditCategoryContainer },
  { path: "/CategoryList", component: CategoryListContainer },
  { path: "/CreateBlogCategory", component: CreateBlogCategoryContainer },
  { path: "/CreateTopCategory", component: CreateTopCategoryList },
  { path: "/EditTopCategory", component: EditTopCategoryList },
  { path: "/TopCategoryList", component: TopCategoryListContainer },
  { path: "/EditBlogCategory", component: EditBlogCategoryContainer },
  { path: "/BlogCategoryList", component: BlogCategoryListContainer },
  { path: "/CreateBlogPost", component: CreateBlogPostContainer },
  { path: "/EditBlogPost", component: EditBlogPostContainer },
  { path: "/BlogPostList", component: BlogPostListContainer },
  { path: "/CreatePaymentMethod", component: CreatePaymentMethodContainer },
  { path: "/PaymentMethodList", component: PaymentMethodListContainer },
  { path: "/EditPaymentMethod", component: EditPaymentMethodContainer },
  { path: "/CreateProductVariant", component: CreateProductVariantContainer },
  { path: "/EditProductVariant", component: EditProductVariantContainer },
  { path: "/ProductVariantList", component: ProductVariantListContainer },
  {
    path: "/CreateProductVariantOption",
    component: CreateProductVariantOptionContainer,
  },
  {
    path: "/CreateProductVariantOptionValue",
    component: CreateProductVariantOptionValueContainer,
  },
  {
    path: "/ProductVariantOptionList",
    component: ProductVariantOptionListContainer,
  },
  {
    path: "/ProductVariantOptionValueList",
    component: ProductVariantOptionValueListContainer,
  },
  {
    path: "/EditProductVariantOption",
    component: EditProductVariantOptionContainer,
  },
  {
    path: "/EditProductVariantOptionValue",
    component: EditProductVariantOptionValueContainer,
  },
  { path: "/CreateCountry", component: CreateCountryContainer },
  { path: "/EditCountry", component: EditCountryContainer },
  { path: "/AllCountryList", component: CountryListContainer },
  { path: "/CreateCity", component: CreateCityContainer },
  { path: "/AllCityList", component: CityListContainer },
  { path: "/EditCity", component: EditCityContainer },
  { path: "/CreateArea", component: CreateAreaContainer },
  { path: "/AllAreaList", component: AreaListContainer },
  { path: "/EditArea", component: EditAreaContainer },
  { path: "/CreateNewAdmin", component: CreateAdminContainer },
  { path: "/AdminList", component: AdminListContainer },
  { path: "/EditAdmin", component: EditAdminContainer },
  { path: "/CreateBrand", component: CreateBrandContainer },
  { path: "/EditBrand", component: EditBrandContainer },
  { path: "/BrandList", component: BrandListContainer },
  { path: "/DiscountTypeList", component: DiscountTypeListContainer },
  { path: "/DiscountList", component: DiscountListContainer },
  { path: "/DiscountSummaryList", component: DiscountSummaryListContainer },
  { path: "/EditDiscountType", component: EditDiscountTypeContainer },
  { path: "/EditDiscount", component: EditDiscountContainer },
  { path: "/EditDiscountSummary", component: EditDiscountSummaryContainer },
  { path: "/EditProduct/:id", component: EditProductContainer },
  { path: "/DuplicateProduct/:id", component: DuplicateProductContainer },
  { path: "/CreateDiscountSummary", component: CreateDiscountSummaryContainer },
  { path: "/CreateDiscountType", component: CreateDiscountTypeContainer },
  { path: "/CreateVoucher", component: CreateVoucherContainer },
  { path: "/EditVoucher", component: EditVoucherContainer },
  { path: "/VoucherList", component: VoucherListContainer },
  { path: "/CreateShippingType", component: CreateShippingTypeContainer },
  { path: "/ShippingTypeList", component: ShippingTypeListContainer },
  { path: "/EditShippingType", component: EditShippingTypeContainer },
  { path: "/CreateCourierProfile", component: CreateCourierProfileContainer },
  { path: "/CourierProfileList", component: CourierProfileListContainer },
  { path: "/EditCourierProfile", component: EditCourierProfileContainer },
  {
    path: "/CreateCourierProductType",
    component: CreateCourierProductTypeContainer,
  },
  {
    path: "/CourierProductTypeList",
    component: CourierProductTypeListContainer,
  },
  {
    path: "/EditCourierProductType",
    component: EditCourierProductTypeContainer,
  },
  { path: "/CreateShippingCost", component: CreateShippingCostContainer },
  { path: "/CreateShippingOptions", component: CreateShippingOptionsContainer },
  { path: "/ShippingCostList", component: ShippingCostListContainer },
  { path: "/ShippingOptionsList", component: ShippingOptionsListContainer },
  { path: "/EditShippingOptions", component: EditShippingOptionsContainer },
  { path: "/CreateCourierCost", component: CreateCourierCostContainer },
  { path: "/CourierCostList", component: CourierCostListContainer },
  { path: "/EditCourierCost", component: EditCourierCostContainer },
  { path: "/PendingReturnPolicy", component: PendingReturnPolicyContainer },
  { path: "/ApprovedReturnPolicy", component: ApprovedReturnPolicyContainer },
  { path: "/RejectedReturnPolicy", component: RejectedReturnPolicyContainer },
  { path: "/EditReturnPolicy", component: EditReturnPolicyContainer },
  { path: "/InvoiceAdmin", component: SellerInvoiceAll },
  { path: "/SellerInvoiceAllAdmin", component: SellerInvoiceAll },
  { path: "/Order-Requisition", component: OrderRequisition },
  { path: "/Report", component: ReportContainer },
  { path: "/PO-Report", component: POReportContainer },
  { path: "/Accounts", component: AccountsContainer },
  { path: "/Seller-Verification", component: AccountsSellerVerification },
  { path: "/OrdersAccounts", component: OrdersAccounts },
  { path: "/WarrantyPeriod", component: WarrantyPeriod },
  { path: "/WarrantyPeriodList", component: WarrantyPeriodList },
  { path: "/CommissionType", component: CommissionType },
  { path: "/CommissionTypeList", component: CommissionTypeList },
  { path: "/WarrantyType", component: WarrantyType },
  { path: "/WarrantyTypeList", component: WarrantyTypeList },
  { path: "/Career", component: Career },
  { path: "/Career-Applicant/:id", component: Applicants },
  { path: "/CreateOutlet", component: CreateOutletContainer },
  { path: "/OutletList", component: OutletListContainer },
  { path: "/UpdateOutlet", component: EditOutletContainer },
  { path: "/CachingList", component: CachingListContainer },
  { path: "/ISRCaching", component: ISRCachingContainer },
  { path: "/Content-Type", component: ContentType },
  { path: "/Content-Post", component: ContentPost },
  { path: "/Size-Chart-Attribute", component: SizeChartAttributes },
  { path: "/Size-Chart-Attributes-List", component: SizeChartAttributeList },
  { path: "/Size-Guide-Measurement", component: SizeGuideMeasurement },
  { path: "/Size-Guide-Measurement-List", component: SizeGuideMeasurementList },
  {
    path: "/Size-Guide-Template-Edit/:id",
    component: SizeChartTemplateViewOrUpdate,
  },
  {
    path: "/CreateAdminStoreBanner",
    component: CreateAdminStoreBannerContainer,
  },
  { path: "/AllStoreBannerList", component: AllStoreBannerListAdminContainer },
  { path: "/UpdateAdminStoreBanner", component: EditAdminStoreBannerContainer },
  { path: "/CreateCampaign", component: CreateCampaignContainer },
  { path: "/EditCampaign", component: EditCampaignContainer },
  { path: "/CampaignList", component: CampaignListContainer },
  {
    path: "/Modify-Campaign-ProductsList",
    component: ModifyProductListContainer,
  },
  {
    path: "/Manage-Campaign-ProductsList",
    component: ManageCampaignProductsContainer,
  },
  { path: "/CreateFestive", component: CreateFestiveContainer },
  { path: "/FestiveList", component: FestiveListContainer },
  { path: "/EditFestive", component: EditFestiveContainer },
  {
    path: "/Add-Festival-ProductsList",
    component: AddFestivalProductListContainer,
  },
  {
    path: "/View-Festival-ProductsList",
    component: ViewFestivalProductListContainer,
  },
  { path: "/Parcel-DeliveryList", component: DeliveryListContainer },
  { path: "/Update-ParcelDelivery", component: UpdateParcelDeliveryContainer },
  { path: "/CreateADBannerType", component: CreateADBannerTypeContainer },
  { path: "/ADBannerTypeList", component: ADBannerTypeListContainer },
  { path: "/UpdateADBannerType", component: EditAdBannerTypeContainer },
  {
    path: "/CreateImageLocation",
    component: CreateADBannerImageLocationContainer,
  },
  {
    path: "/ADBannerImageLocationList",
    component: ADBannerImageLocationListContainer,
  },
  {
    path: "/UpdateADBannerImageLocation",
    component: EditADBannerImageLocationContainer,
  },
  { path: "/CreateImageType", component: CreateADBannerImageTypeContainer },
  { path: "/ADBannerImageTypeList", component: ADBannerImageTypeListContainer },
  {
    path: "/UpdateADBannerImageType",
    component: EditADBannerImageTypeContainer,
  },
  { path: "/Create-ADBanner", component: CreateAdBannerContainer },
  { path: "/ADBannerList", component: ADBannerListContainer },
  { path: "/Edit-ADBanner", component: EditAdBannerContainer },
  { path: "/CreateProject", component: CreateProjectContainer },
  { path: "/EditProject", component: EditProjectContainer },
  { path: "/ProjectList", component: ProjectListContainer },
  {
    path: "/CreateSearchSuggestion",
    component: CreateSearchSuggestionContainer,
  },
  { path: "/SearchSuggestionsList", component: SearchSuggestionsListContainer },
  { path: "/CreateAppRelease", component: CreateAppReleaseContainer },
  { path: "/EditAppRelease", component: EditAppReleaseContainer },
  { path: "/AppReleaseList", component: AppReleaseListContainer },
  { path: "/CreatePurchaseOrder", component: CreatePurchaseOrderContainer },
  { path: "/PurchaseOrderList", component: PurchaseOrderListContainer },
  {
    path: "/CreateGeneralPurchaseOrder",
    component: CreateGeneralPurchaseOrderContainer,
  },
  {
    path: "/GeneralPurchaseOrderList",
    component: GeneralPurchaseOrderListContainer,
  },
  {
    path: "/CreatePurchaseOrderReceived",
    component: CreatePurchaseOrderReceivedContainer,
  },
  {
    path: "/ReceivedPurchaseOrderList",
    component: ReceivedPurchaseOrderListContainer,
  },
  {
    path: "/EditPurchaseOrderReceived",
    component: EditPurchaseOrderReceivedContainer,
  },
  {
    path: "/PurchaseOrderReceivedApprovalList",
    component: PurchaseOrderReceivedApprovalListContainer,
  },
  { path: "/CreateReturnPO", component: CreateReturnPOContainer },
  { path: "/ReturnPOList", component: ReturnPOListContainer },
  { path: "/EditReturnPO", component: EditReturnPOContainer },
  { path: "/ReturnPOApprovalList", component: ReturnPOApprovalListContainer },
  { path: "/CreatePaymentAdvice", component: CreatePaymentAdviceContainer },
  { path: "/EditPaymentAdvice", component: EditPaymentAdviceContainer },
  { path: "/PaymentAdviceList", component: PaymentAdviceListContainer },
  {
    path: "/PaymentAdviceApprovalList",
    component: PaymentAdviceApprovalListContainer,
  },
  { path: "/PaymentAdviceReport", component: PaymentAdviceReportContainer },
  { path: "/CategoryWiseReportAudit", component: CategoryWiseReportAuditContainer },
  { path: "/CreateStoreLocation", component: CreateStoreLocationContainer },
  { path: "/StoreLocationList", component: StoreLocationListContainer },
  { path: "/EditStoreLocation", component: EditStoreLocationContainer },
  { path: "/StockReport", component: StockReportListContainer },
  { path: "/GenerateBarcode", component: GenerateBarcodeContainer },
  { path: "/BillList", component: BillListContainer },
  { path: "/ReturnBillList", component: ReturnBillListContainer },
  { path: "/PreviousReturnBillList", component: PrevReturnBillListContainer },
  { path: "/CreateInventory", component: CreateInventoryList },
  { path: "/EditInventory", component: EditInventoryList },
  { path: "/InventoryList", component: InventoryListContainer },
  { path: "/BankAccountsAdmin", component: BankAccountsAdminContainer },
  { path: "/CreateCampaignType", component: CreateCampaignTypeContainer },
  { path: "/EditCampaignType", component: EditCampaignTypeContainer },
  { path: "/CampaignTypeList", component: CampaignTypeListContainer },
  {
    path: "/CreateJournalCategory",
    component: CreateVideoBlogCategoryContainer,
  },
  { path: "/JournalCategoryList", component: VideoBlogCategoryListContainer },
  { path: "/EditJournalCategory", component: EditVideoBlogCategoryContainer },
  { path: "/CreateJournalPost", component: CreateVideoBlogPostContainer },
  { path: "/VideoJournalPostList", component: VideoBlogPostListContainer },
  { path: "/EditJournalPost", component: EditVideoBlogPostContainer },
];
